import { ViewModel } from "../mvvm/ViewModel.js";
/** Event categories the backend feed can filter on (#250). */
export const ACTIVITY_CATEGORIES = [
    "signup",
    "verify",
    "slug",
    "key",
    "publish",
    "payment",
    "abuse",
];
export const ACTIVITY_PAGE_SIZE = 50;
/** Platform console: dev-platform activity feed with type + tenant filters (#250). */
export class PlatformActivityViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ events: [], type: "", tenant: "", limit: ACTIVITY_PAGE_SIZE, hasMore: false });
        this.client = client;
    }
    setType(type) {
        this.setState({ type: type.trim(), limit: ACTIVITY_PAGE_SIZE });
    }
    setTenant(tenant) {
        this.setState({ tenant: tenant.trim(), limit: ACTIVITY_PAGE_SIZE });
    }
    /** Throws on failure so a LivePanel can surface it. */
    async load() {
        const { type, tenant, limit } = this.state;
        const opts = type || tenant ? { ...(tenant ? { tenant } : {}), ...(type ? { type } : {}) } : undefined;
        const events = await this.client.listAdminEvents(limit, opts);
        this.setState({ events, hasMore: events.length >= limit });
    }
    /** Next page: widen the window (the feed API is limit-based) and reload. */
    async loadMore() {
        this.setState({ limit: this.state.limit + ACTIVITY_PAGE_SIZE });
        await this.load();
    }
}
//# sourceMappingURL=PlatformActivityViewModel.js.map